import { render, staticRenderFns } from "./SearchScreen.vue?vue&type=template&id=968887be&"
import script from "./SearchScreen.vue?vue&type=script&lang=js&"
export * from "./SearchScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports